module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#action",
      toString: function () {
        return this.url;
      }
    }